<template>
    <div class="loading-container">
        <svg width="100%" height="100%" viewBox="0 0 224 212" version="1.1"
             xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xml:space="preserve"
             xmlns:serif="http://www.serif.com/"
             style="fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2;">
        <g transform="matrix(1,0,0,1,-5.2143,1.42109e-14)">
            <g transform="matrix(0.533913,0,0,0.533913,-67.5824,-28.9987)">
                <path
                    d="M348.21,180.655L411.34,217.103L411.34,289.999L348.21,326.447L285.08,289.999L285.08,217.103L348.21,180.655Z"
                    class="loader-center"/>
            </g>
            <g transform="matrix(0.533913,0,0,0.533913,-107.288,-94.454)">
                <path
                    d="M348.21,180.655L411.34,217.103L411.34,289.999L348.21,326.447L285.08,289.999L285.08,217.103L348.21,180.655Z"
                    class="loader loader-two"/>
            </g>
            <g transform="matrix(0.533913,0,0,0.533913,-146.994,-28.9987)">
                <path
                    d="M348.21,180.655L411.34,217.103L411.34,289.999L348.21,326.447L285.08,289.999L285.08,217.103L348.21,180.655Z"
                    class="loader loader-three"/>
            </g>
            <g transform="matrix(0.533913,0,0,0.533913,-107.288,37.2382)">
                <path
                    d="M348.21,180.655L411.34,217.103L411.34,289.999L348.21,326.447L285.08,289.999L285.08,217.103L348.21,180.655Z"
                    class="loader loader-four"/>
            </g>
            <g transform="matrix(0.533913,0,0,0.533913,-28.8766,37.2382)">
                <path
                    d="M348.21,180.655L411.34,217.103L411.34,289.999L348.21,326.447L285.08,289.999L285.08,217.103L348.21,180.655Z"
                    class="loader loader-five"/>
            </g>
            <g transform="matrix(0.533913,0,0,0.533913,8.82911,-28.9987)">
                <path
                    d="M348.21,180.655L411.34,217.103L411.34,289.999L348.21,326.447L285.08,289.999L285.08,217.103L348.21,180.655Z"
                    class="loader loader-six"/>
            </g>
            <g transform="matrix(0.533913,0,0,0.533913,-28.8766,-96.454)">
                <path
                    d="M348.21,180.655L411.34,217.103L411.34,289.999L348.21,326.447L285.08,289.999L285.08,217.103L348.21,180.655Z"
                    class="loader loader-seven"/>
            </g>
        </g>
    </svg>
        <p>{{message}}</p>
    </div>
</template>


<script>
    export default {
        name: 'loader',
        props: {
            message: {
                type: String,
                default: null
            }
        },
    }
</script>

<style lang="scss" scoped>
    .loading-container {
        height:250px;
        transform:scale(0.6);
        p {
            text-align:center;
            font-size:28px;
            font-family: Lato,sans-serif;
            margin-top:20px;
        }
        svg {
            transform:rotateY(90deg);
            animation-name: rotate;
            animation-duration: 2s;
            animation-fill-mode: forwards;
        .loader {
            fill: #efefef;
            animation-name: color;
            animation-duration: 3.5s;
            animation-iteration-count:infinite;
            transition-timing-function: linear;
        }

        .loader-center {
            animation-name: opacity-center;
            animation-duration: 10s;
            animation-iteration-count:infinite;
            fill:#038E9E;
            opacity:0.5
        }

        .loader-two {

            animation-delay: 3s;
        }
        .loader-three {

            animation-delay: 2.5s;
        }
        .loader-four {

            animation-delay: 2s;
        }
        .loader-five {

            animation-delay: 1.5s;
        }
        .loader-six {

            animation-delay: 1s;
        }
        .loader-seven {

            animation-delay: 0s;
        }
        }
    }

    @keyframes rotate {

        to {
            transform: rotateY(0deg)
            }
   }
    @keyframes opacity-center {
        to {
        opacity:1
        }
    }
    @keyframes color {
    from {
        fill: #005697
    }
    to{
        fill:#CCE6F4
    }
}
</style>
